import { useQuery } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";
import { Api_EndPoints } from "../../utils/Api_EndPoints";

const getDeductions = async ({companyCode}) => {
  const data = await http_payroll.get(
    `${Api_EndPoints.GetDeductions}?isAll=true&CompanyCode=${companyCode}`
  );
  return data;
};

export const useGetDeductionsQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetDeductions],
    queryFn: () => getDeductions(companyCode),
    refetchOnWindowFocus: false,
  });
};
